import React, { Children, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { Box, Button, Divider, Grid } from "@mui/material";
import { StyledButton } from "../../../../../../shared/components/buttons/custom-button";
import FormBuilderV4 from "../../../../../../shared/components/form-builder/form-builder-v4";
import {
  BuyerSellerDetails,
  buyerSellerDetails,
  getTcSellerInformation,
  getTcBuyerInformation,
  INonCertifiedTrader,
  mapBuyerSellerDetailsApiResponseToInitialValues,
  mapReturnTcAutofillFromSource,
  mapPayload,
} from "../../../tc-models/tc-req-dto/tc-buyer-seller-details.req_dto";
import { buyerSellerDetailsService } from "../../../tc-service/buyer-seller-details.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useNotification from "../../../../../../shared/hooks/useNotification";
import { useFormActions } from "../../../../../../shared/hooks/form-builder.hooks";
import { useApi } from "../../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../../shared/components/loaders/page-loader";
import {
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../../shared/app-configs/tc-app-configs";
import { translateTcV4ValidationDetail } from "../../../../../../shared/utils/tc-v4-validation-messages.utils";
import { dtrackItService } from "../../../tc-service/dtrackit.service";
import { CustomButton } from "../../../../../../shared/components/buttons/buttons";
import ModalPopup from "../../../../../../shared/components/modals/custom-popup";
import RawMaterialInfo from "./non-certified-trader";
import { ITcProductRawMaterialInformation } from "../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import NonCertifiedTraderInfo from "./non-certified-trader";
import { useFormik } from "formik";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";
import { InnerButton } from "../../../../../../shared/components/buttons/floating-button-container";
import { RestrictedDataValidation } from "../../../../../../shared/utils/custom-validation.utils";
import {
  applyApiFieldErrorsToFormik,
  extractApiFieldErrors,
  scrollToFirstFormError,
} from "../../../../../../shared/utils/form-error.utils";
import { standardCodeFromValue } from "../incoming-tc-details/incoming-details-apis";
import {
  filterCountryOptionsByState,
  getCountryCodeFromState,
  hasInvalidPartyLocationValue,
  normalizeTownFromLookup,
  unwrapScSearchItems,
} from "./buyer-seller-lookup.utils";

// Backend buyer/seller validation errors use the nested API payload names —
// map them to the flat Formik field names so the exact inputs highlight inline.
const BUYER_SELLER_API_FIELD_TO_FORM_FIELD: Record<string, string> = {
  "tcSellerInformation.sellerTeId": "sellerTEId",
  "tcSellerInformation.sellerName": "sellerName",
  "tcSellerInformation.sellerStreetAddress": "sellerAddress1",
  "tcSellerInformation.sellerTown": "sellerTown",
  "tcSellerInformation.sellerPostcode": "sellerPostcode",
  "tcSellerInformation.sellerStateOrProvince": "sellerStateOrProvince",
  "tcSellerInformation.sellerCountryOrArea": "sellerCountryOrArea",
  "tcSellerInformation.sellerScNo": "sellerSCNumber",
  "tcSellerInformation.sellerCertifiedOrganizationName":
    "sellerCertifiedOrganizationName",
  "tcSellerInformation.sellerCbClientNo": "sellerLicenseNumber",
  "tcBuyerInformation.buyerTeId": "buyerTEId",
  "tcBuyerInformation.buyerName": "buyerName",
  "tcBuyerInformation.buyerStreetAddress": "buyerAddress1",
  "tcBuyerInformation.buyerTown": "buyerTown",
  "tcBuyerInformation.buyerPostcode": "buyerPostcode",
  "tcBuyerInformation.buyerStateOrProvince": "buyerStateOrProvince",
  "tcBuyerInformation.buyerCountryOrArea": "buyerCountryOrArea",
  "tcBuyerInformation.buyerScNo": "buyerSCNumber",
  "tcBuyerInformation.buyerScCbLicensingCode": "buyerScCbLicensingCode",
  "tcBuyerInformation.buyerCertifiedOrganizationName":
    "buyerCertifiedOrganizationName",
};

interface SellerCertifiedProductsProps {
  onNextTab: () => Promise<void>;
}

const SellerCertifiedProducts: React.FC<SellerCertifiedProductsProps> = ({
  onNextTab,
}) => {
  const searchApi = useApi();
  const { notify } = useNotification();
  const { TE_ID, formtype } = useParams<string>();
  const hasCreateTc: boolean = formtype === "create-tc";
  const hasSubmitTc: boolean = formtype === "submited-tc";
  const hasRejectedTc: boolean = formtype === "rejected-tc";

  const [countries, setCountries] = useState([]);
  const [states, setState] = useState([]);
  const [getBuyerStates, setBuyerStates] = useState([]);
  const [getSellerStates, setSellerStates] = useState([]);
  const [buyerCountryFilterCode, setBuyerCountryFilterCode] = useState("");
  const [sellerCountryFilterCode, setSellerCountryFilterCode] = useState("");
  const [buyerScCbLicensingCodes, setBuyerScCbLicensingCodes] = useState<any[]>([]);

  const [getBuyerName, setBuyerName] = useState("");
  const [getBuyingOnBehalfOfFlag, setBuyingOnBehalfOfFlag] = useState("Yes");

  const { loading, executeGet } = useApi();
  // Dedicated hook instance for the save POST. Sharing `loading` with the page
  // loader unmounted the form during save, which reset every entered value when
  // the save failed (the "form data resets" bug this tab used to work around
  // with a delayed restore hack).
  const saveApi = useApi();
  const { isRestrictPopUpSave,setCountryCodes, setStates, getTCStandardGOTS, cbLicensingCode } =
    useTransactionCertificateStore();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [visible, setVisible] = useState({
    sellerTEId: true,
    sellerName: true,
    buyerSeacrhTEId: true,
    disableBuyerTEId: false,
    disableBuyerTEName: false,
    buyerSearchName: true,
    buyerTEIdLabel: true,
    sellerTEIdLabel: true,
  });
  const [disable, setDisable] = useState({
    sellerCountry: true,
    sellerState: true,
    buyerCountry: true,
    buyerState: true,
    sellerPostCode: true,
    buyerPostCode: true,
    sellerTown: true,
    buyerTown: true,
    buyerAddress1: true,
    sellerAddress1: true,
  });

  const [sellerScStandards, setSellerScStandards] = useState<string[]>([]);
  const [tcStandards, setTcStandards] = useState<string[]>([]);
  const [isReturnTc, setIsReturnTc] = useState(false);
  const [isBuyerTeCertifiedVisbile, setBuyerTeCertifiedVisbile] = useState<boolean>(true);
  const [tcIssueDate, setTcIssueDate] = useState<string>("");
  const [initialValues, setInitialValues] = useState<BuyerSellerDetails>(buyerSellerDetails);
  const [isDataInitialized, setIsDataInitialized] = useState<boolean>(false);
  const nonCertifiedTraderDatas: INonCertifiedTrader[] = [];

  const [stepData, setStepData] = useState({
    nonCertifiedTrader: nonCertifiedTraderDatas,
  });
  const navigate = useNavigate();

  const { getCurrentFormValues, updateField } = useFormActions(
    "buyer-seller-products"
  );
  const { getCurrentFormValues: getTransactionDetailsFormValues } = useFormActions(
    "Transaction-Details"
  );

  const setZustandInitialState = (initial?: any) => {
    const defalutState: any = initialValues;
    Object.entries(initial ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };



const TE_ID_PATTERN = /^TE-\d{8}$/;
const isNaValue = (value?: string | null) =>
  typeof value === "string" && value.trim().toLowerCase() === "na";

const isReturnValue = (value?: string | null) => {
  const normalized = String(value || "").trim().toUpperCase();
  return normalized === "Y" || normalized === "YES";
};

const hasRestrictedPlaceholder = (value?: string | null, allowNa = false) => {
  if (!value) return false;
  if (allowNa && isNaValue(value)) return false;
  return RestrictedDataValidation.isRestrictedData(value);
};

// DAT-501 "seller SC Number" rule 3 / "tc standard" submission rule: every standard
// selected for the TC must be present on the attached Seller SC (86ajey1h1).
// Returns the TC standards the SC does NOT carry; both sides are normalized to
// short codes so v3 SCs storing full labels still compare correctly. Skipped
// (returns []) when either list is unknown — the submit-time backend check stays
// authoritative for those.
const missingSellerScStandards = (
  tcStandards: string[],
  scStandards: string[]
): string[] => {
  if (!Array.isArray(tcStandards) || !Array.isArray(scStandards)) return [];
  if (tcStandards.length === 0 || scStandards.length === 0) return [];
  const scCodes = new Set(
    scStandards.map(standardCodeFromValue).filter(Boolean)
  );
  return tcStandards.filter((standard) => {
    const code = standardCodeFromValue(standard);
    return code && !scCodes.has(code);
  });
};





  const buyerSellerDetailsValidationSchema = Yup.object().shape({
    sellerLicenseNumber: Yup.string()
      .required("Seller Client Number is required")
      .max(50, "Maximum 50 Characters is allowed")
      .test(
        "seller-client-placeholder",
        isReturnTc
          ? 'N/A, Not available, null are not allowed. Use "na" if not applicable'
          : "Restricted placeholder values are not allowed",
        (value) => !hasRestrictedPlaceholder(value, isReturnTc)
      ),
    // For a Return TC, "na" is a valid Seller Certified Organization Name (the seller
    // mirrors the original buyer and may be non-certified), but it must stay consistent
    // with the Seller SC Number: both "na" or both real (matches the backend rule
    // tc_v4_section_validation: certified org must be "na" when SC No is "na").
    sellerCertifiedOrganizationName: Yup.string()
      .required("Seller Certified Organization Name is required")
      .max(255, "Maximum 255 Characters is allowed")
      .test("seller-cert-org-conditional", function (value) {
        if (isReturnTc) {
          const { sellerSCNumber } = this.parent;
          if (isNaValue(sellerSCNumber)) {
            if (!isNaValue(value)) {
              return this.createError({
                message: 'Seller Certified Organization Name must be "na" when Seller SC Number is "na"',
              });
            }
            return true;
          }
          if (!value || value.trim() === "") {
            return this.createError({ message: "Seller Certified Organization Name is required" });
          }
          if (hasRestrictedPlaceholder(value)) {
            return this.createError({ message: "Restricted placeholder values are not allowed" });
          }
          return true;
        }
        if (hasRestrictedPlaceholder(value)) {
          return this.createError({ message: "Restricted placeholder values are not allowed" });
        }
        return true;
      }),
    sellerCountryOrArea: Yup.string().required(
      "Seller Country/Area is required"
    ).test("seller-country-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),
    buyerLicenseNumber: Yup.string().nullable(),
    buyerScCbLicensingCode: Yup.string().when("isBuyerTeCertified", {
      is: (value: string) => value !== "No",
      then: (schema) =>
        schema
          .required("Buyer CB Licensing Code is required")
          .matches(/^CB-[A-Z]{3}$/, "Buyer CB Licensing Code must match CB-XXX"),
      otherwise: (schema) => schema.nullable(),
    }),
      // .when([], {
      //   is: () => getTCStandardGOTS,
      //   then: (schema) => schema.required("Buyer Client Number is required"),
      //   otherwise: (schema) => schema.nullable(),
      // }),
    // buyerCertifiedOrganizationName: Yup.string()
    //   .required("Organzation Name is required"),
      // .when([], {
      //   is: () => getTCStandardGOTS,
      //   then: (schema) =>
      //     schema.required("Buyer Certified Organization Name is required"),
      //   otherwise: (schema) => schema.nullable(),
      // }),

    // sellingOnBehalfOfFlag: Yup.string()
    //   .when([], {
    //     is: () => !getTCStandardGOTS,
    //     then: (schema) =>
    //       schema.required("Selling On Behalf Of Flag is required"),
    //   })
    //   .max(1, "Maximum 1 Character is allowed"),

    sellerName: Yup.string()
      .required("Seller Name is required")
      .max(255, "Maximum 255 Characters allowed")
      .test("seller-name-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    sellerTEId: Yup.string()
      .required("Seller TE ID is required")
      .matches(TE_ID_PATTERN, "Seller TE ID must match TE-########")
      .test(
        "sellerTEId-validation",
        "Custom Error: Seller TE ID must be different from Buyer TE ID",
        function (value) {
          const { buyerTEId } = this.parent;
          if (!value) return true;
          if (value === buyerTEId) {
            return this.createError({
              message: "Buyer TE ID must not be equal to Seller TE ID",
            });
          }
          return true;
        }
      ),

    sellerAddress1: Yup.string()
      .required("Seller Address Line 1 is required")
      .max(1000, "Maximum 1000 Characters is allowed")
      .test("seller-address-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    sellerStateOrProvince: Yup.string()
      .required("Seller State/Province required")
      .test("seller-state-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    // Seller SC Number is a dropdown (real SC) for normal TCs. For a Return TC it is a
    // free-text field where "na" is a valid value (seller mirrors a possibly non-certified
    // original buyer); only "na" is allowed as a placeholder — other restricted strings
    // (n/a, null, not applicable...) are still blocked to match the backend.
    sellerSCNumber: Yup.string()
      .required("Seller SC Number is required")
      .max(50, "Maximum 50 Characters is allowed")
      .test("seller-sc-placeholder", 'N/A, Not available, null are not allowed. Use "na" if not applicable', (value) => !hasRestrictedPlaceholder(value, isReturnTc)),

    // buyingOnBehalfOfFlag: Yup.string().when([], {
    //   is: () => !getTCStandardGOTS,
    //   then: (schema) => schema.required("Buying On Behalf Of Flag is required"),
    // }),

    buyerName: Yup.string()
      .required("Buyer Name is required")
      .max(255, "Maximum 255 Characters is allowed")
      .test("buyer-name-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    buyerTEId: Yup.string()
      .required()
      .matches(TE_ID_PATTERN, "Buyer TE ID must match TE-########")
      .test(
        "buyerTEId-validation",
        "Custom Error: Buyer TE ID must be different from Seller TE ID",
        function (value) {
          const { sellerTEId } = this.parent;
          if (!value) return true;
          if (value === sellerTEId) {
            return this.createError({
              message: "Seller TE ID must not be equal to Buyer TE ID",
            });
          }
          return true;
        }
      ),

    buyerAddress1: Yup.string()
      .required("Buyer Address Line 1 is required")
      .max(1000, "Maximum 1000 Characters is allowed")
      .test("buyer-address-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    buyerStateOrProvince: Yup.string()
      .required("Buyer State/Province is required")
      .test("buyer-state-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    buyerCountryOrArea: Yup.string()
      .required("Buyer Country or Area is required")
      .test("buyer-country-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    nonCertifiedTrader: Yup.array().of(
      Yup.object().shape({
        sellerNonCertifiedTraderName: Yup.string()
          .nullable()
          .required("Seller non-certified trader name is required; use na if not applicable")
          .max(255, "Maximum 255 Characters is allowed")
          .test('no-restricted-data', 'N/A, Not available, n/a are not allowed. Use "na" if not applicable',
            (value) => !hasRestrictedPlaceholder(value, true)),
        sellerNonCertifiedTraderTeId: Yup.string()
          .nullable()
          .test("noncert-teid-required", "Seller non-certified trader TE-ID is required when trader name is not na", function(value) {
            const traderName = this.parent?.sellerNonCertifiedTraderName;
            if (!traderName || isNaValue(traderName)) return true;
            return !!value;
          })
          .test("noncert-teid-format", "Seller non-certified trader TE-ID must match TE-########", (value) => {
            if (!value) return true;
            return TE_ID_PATTERN.test(value);
          }),
      })
    ).min(1, "Please add Non-Certified Trader Info"),
    buyerAddress2: Yup.string().nullable(), // Optional field
    buyerAddress3: Yup.string().nullable(), // Optional field
    buyerPostcode: Yup.string()
      .required("Buyer Postcode is required")
      .test(
        "valid-party-location",
        'Whitespace-only, N/A, Not available, and null are not allowed. Use "na" if not available',
        (value) => !hasInvalidPartyLocationValue(value)
      ),
    buyerTown: Yup.string()
      .required("Buyer Town is required")
      .max(255, "Maximum 255 Characters is allowed")
      .test(
        "valid-party-location",
        'Whitespace-only, N/A, Not available, and null are not allowed. Use "na" if not available',
        (value) => !hasInvalidPartyLocationValue(value)
      ),
    // isBuyerTeCertified: Yup.string(),
    sellerNonCertifiedTraderName: Yup.string()
      .nullable()
      .test('no-restricted-data', 'N/A, Not available, n/a are not allowed. Use "na" if not applicable', 
        (value) => {
          if (!value) return true;
          const trimmedValue = value.trim();
          // Allow "na" as it's a valid value for "not applicable"
          if (trimmedValue === "na") return true;
          // Use the imported function to check for other restricted values
          return !RestrictedDataValidation.isRestrictedData(value);
        }),
    SellerNonCertifiedTraderTEId: Yup.string().nullable(), // Optional field
    sellerPostcode: Yup.string()
      .required("Seller Postcode is required")
      .test(
        "valid-party-location",
        'Whitespace-only, N/A, Not available, and null are not allowed. Use "na" if not available',
        (value) => !hasInvalidPartyLocationValue(value)
      ),
    sellerTown: Yup.string()
      .required("Seller Town is required")
      .max(255, "Maximum 255 Characters is allowed")
      .test(
        "valid-party-location",
        'Whitespace-only, N/A, Not available, and null are not allowed. Use "na" if not available',
        (value) => !hasInvalidPartyLocationValue(value)
      ),
    tcSellerProductDeclarations: Yup.string().nullable(),
    buyerSCNumber: Yup.string()
      .required("Buyer SC Number is required")
      .max(50, "Maximum 50 Characters is allowed")
      .test('buyer-sc-placeholder', 'N/A, Not available, n/a are not allowed. Use "na" if not applicable',
        (value) => !hasRestrictedPlaceholder(value, true))
      .test(
        "unique-sc-number",
        "Buyer SC Number must be different from Seller SC Number",
        function(value) {
          const { sellerSCNumber } = this.parent;
          if (isNaValue(value)) return true;
          if (!value || !sellerSCNumber) return true;
          return value !== sellerSCNumber;
        }
      ),
    buyerCertifiedOrganizationName: Yup.string()
      .required("Buyer Certified Organization Name is required")
      .max(255, "Maximum 255 Characters is allowed")
      .test("buyer-cert-org-conditional", function(value) {
        const { buyerSCNumber } = this.parent;
        if (isNaValue(buyerSCNumber)) {
          if (!isNaValue(value)) {
            return this.createError({ message: 'Buyer Certified Organization Name must be "na" when Buyer SC Number is "na"' });
          }
          return true;
        }
        if (!value || value.trim() === "") {
          return this.createError({ message: "Buyer Certified Organization Name is required" });
        }
        if (hasRestrictedPlaceholder(value)) {
          return this.createError({ message: "Restricted placeholder values are not allowed" });
        }
        return true;
      }),
  });

  const fetchSCDetailsFromAPI = async (query: string, teId: string, dropDown: 'Buyer' | 'Seller') => {
    const trimmedQuery = String(query || "").trim();
    try {
      if (!teId || teId === "") {
        return [];
      }
      const selectedCbLicensingCode =
        dropDown === "Buyer"
          ? formRef.current?.values?.buyerScCbLicensingCode
          : cbLicensingCode;
      if (!selectedCbLicensingCode) {
        if (trimmedQuery) {
          notify(`Please select ${dropDown} CB Licensing Code first`, "warning");
        }
        return [];
      }
      const response: any = await searchApi.executeGet(
        TCAppConfig.GET_BUYER_SELLER_SC_NO_V4,
        { 
          scNo: query, 
          scCbLicensingCode: selectedCbLicensingCode,
          teId: teId,
          tcId: TE_ID,
          dropDown: dropDown
        }
      );
      
      const items = unwrapScSearchItems(response?.data);
      if (trimmedQuery && items.length === 0) {
        if (dropDown === "Seller") {
          formRef.current?.setFieldValue("sellerSCNumber", "");
          formRef.current?.setFieldValue("sellerCertifiedOrganizationName", "");
          formRef.current?.setFieldValue("sellerLicenseNumber", "");
          setSellerScStandards([]);
        } else {
          formRef.current?.setFieldValue("buyerSCNumber", "");
          formRef.current?.setFieldValue("buyerCertifiedOrganizationName", "");
          formRef.current?.setFieldValue("buyerLicenseNumber", "");
        }
        notify(
          dropDown === "Seller"
            ? `No valid Seller SC found for "${trimmedQuery}" for the given seller TE-ID: ${teId}`
            : `No valid Buyer SC found for "${trimmedQuery}"`,
          "error"
        );
      }
      return items.map((item: any) => ({
        label: item.scNo,
        value: item.scNo,
        scNo: item.scNo,                    // Add for sellerSCValueChange
        certifiedOrganizationName: item.certifiedOrganizationName,
        certifiedOrganizationCbClientNo: item.certifiedOrganizationCbClientNo || "",
        scCbLicensingCode: item.scCbLicensingCode || selectedCbLicensingCode,
        scStandard: item.scStandard || [],
        scValidFromDate: item.scValidFromDate || item.validFrom || item.validFromDate || "",
        scValidUntilDate: item.scValidUntilDate || item.validUntil || item.validUntilDate || "",
        scExtendedUntilDate: item.scExtendedUntilDate || item.extendedUntil || item.extendedUntilDate || ""


      }));
    } catch (error) {
      console.error("Error fetching SC details:", error);
      if (trimmedQuery) {
        notify(`Unable to search ${dropDown} SC numbers. Please try again.`, "error");
      }
      return [];
    }
  };

  const applySellerTownFromLookup = (city: unknown) => {
    const normalizedTown = normalizeTownFromLookup(city);
    setDisable((prev) => ({
      ...prev,
      sellerTown: normalizedTown.length > 0,
    }));
    formRef.current?.setFieldValue("sellerTown", normalizedTown);
  };
  
  const handleSellerSCValueChange = (value: any) => {
    if (value == null) {
      formRef.current.setFieldValue("sellerSCNumber", "");
      formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
      formRef.current.setFieldValue("sellerLicenseNumber", "");
      setSellerScStandards([]); // Clear standards
    } else {
      const buyerSCNumber = formRef.current.values.buyerSCNumber;
      if (buyerSCNumber && (value.value === buyerSCNumber || value.scNo === buyerSCNumber)) {
        notify("Seller SC Number must be different from Buyer SC Number", "error");
        formRef.current.setFieldValue("sellerSCNumber", "");
        formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
        formRef.current.setFieldValue("sellerLicenseNumber", "");
        setSellerScStandards([]);
        return;
      }
      // DAT-501 seller-SC rule 3: every TC standard must be present on the SC —
      // reject the selection immediately so the mismatch never reaches save (86ajey1h1).
      const missingStandards = isReturnTc
        ? []
        : missingSellerScStandards(tcStandards, value.scStandard || []);
      if (missingStandards.length > 0) {
        notify(
          `Selected Seller SC does not include the TC standard(s): ${missingStandards.join(
            ", "
          )}. Select a different Seller SC or change the TC standard.`,
          "error"
        );
        formRef.current.setFieldValue("sellerSCNumber", "");
        formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
        formRef.current.setFieldValue("sellerLicenseNumber", "");
        setSellerScStandards([]);
        return;
      }

      if (!isReturnTc && tcIssueDate) {
        const issueDate = new Date(tcIssueDate);
        const validFrom = value.scValidFromDate ? new Date(value.scValidFromDate) : null;
        const validUntil = value.scValidUntilDate ? new Date(value.scValidUntilDate) : null;
        const extendedUntil = value.scExtendedUntilDate ? new Date(value.scExtendedUntilDate) : null;
        const expiryDate = extendedUntil && extendedUntil.getTime() > 0 ? extendedUntil : validUntil;

        if (issueDate && validFrom && expiryDate) {
          const warnTime = expiryDate.getTime() + 90 * 24 * 60 * 60 * 1000;
          const errorTime = expiryDate.getTime() + 110 * 24 * 60 * 60 * 1000;

          if (issueDate.getTime() < validFrom.getTime()) {
            notify("TC Issue Date cannot be before the Seller SC Valid From Date", "error");
            formRef.current.setFieldValue("sellerSCNumber", "");
            formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
            formRef.current.setFieldValue("sellerLicenseNumber", "");
            setSellerScStandards([]);
            return;
          }

          if (issueDate.getTime() > errorTime) {
            notify(
              "TC Issue Date must be on or before the Seller SC validity date + 110 days. This Seller SC cannot be selected.",
              "error"
            );
            formRef.current.setFieldValue("sellerSCNumber", "");
            formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
            formRef.current.setFieldValue("sellerLicenseNumber", "");
            setSellerScStandards([]);
            return;
          }

          if (issueDate.getTime() > warnTime) {
            const proceed = window.confirm(
              "SC validity expired 90 days ago. Do you wish to proceed?"
            );
            if (!proceed) {
              formRef.current.setFieldValue("sellerSCNumber", "");
              formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
              formRef.current.setFieldValue("sellerLicenseNumber", "");
              setSellerScStandards([]);
              return;
            }
          }
        }


      }

      formRef.current.setFieldValue("sellerSCNumber", value.value || value.scNo);
      formRef.current.setFieldValue("sellerCertifiedOrganizationName", value.certifiedOrganizationName);
      // Seller CB Client Number is autofilled (read-only) from the selected SC's certified org
      formRef.current.setFieldValue("sellerLicenseNumber", value.certifiedOrganizationCbClientNo || "");
      setSellerScStandards(value.scStandard || []);
    }
  };
  
  const handleBuyerSCValueChange = (value: any) => {
    if (value == null) {
      formRef.current.setFieldValue("buyerSCNumber", "");
      formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
    } else {
      formRef.current.setFieldValue("buyerSCNumber", value.scNo);
      formRef.current.setFieldValue("buyerCertifiedOrganizationName", value.certifiedOrganizationName);
      formRef.current.setFieldValue("buyerScCbLicensingCode", value.scCbLicensingCode || "");
    }
  };

  useEffect(() => {
    // Apply a fully-mapped BuyerSellerDetails object to the form: visibility flags,
    // disabled states, dependent state dropdowns, and the initial Formik/Zustand values.
    // Shared by the normal "load own saved data" path and the Return-TC auto-fill path.
    const applyBuyerSellerData = async (data: BuyerSellerDetails) => {
      if (data.nonCertifiedTrader.length > 0) {
        setStepData({ nonCertifiedTrader: data.nonCertifiedTrader });
      }

      // Update visibility flags
      if (data?.sellerTEId && data?.sellerTEId !== "") {
        setVisible((prev) => ({ ...prev, sellerTEIdLabel: false }));
      }
      if (data?.buyerName) {
        setBuyerName(data?.buyerName);
      }
      if (data?.buyerTEId && data?.buyerTEId !== "") {
        setVisible((prev) => ({ ...prev, buyerTEIdLabel: false }));
      }

      // Load states based on countries. If DTrackIt supplied a state but no
      // country, derive the country from the state prefix so the state remains
      // visible and the missing-country dropdown can be restricted correctly.
      const buyerStateCountryCode = !data?.buyerCountryOrArea
        ? getCountryCodeFromState(data?.buyerStateOrProvince)
        : "";
      const sellerStateCountryCode = !data?.sellerCountryOrArea
        ? getCountryCodeFromState(data?.sellerStateOrProvince)
        : "";
      setBuyerCountryFilterCode(buyerStateCountryCode);
      setSellerCountryFilterCode(sellerStateCountryCode);
      if (data?.buyerCountryOrArea) {
        await getState(data.buyerCountryOrArea, true);
      } else if (buyerStateCountryCode) {
        await getState(buyerStateCountryCode, true);
      }
      if (data?.sellerCountryOrArea) {
        await getState(data.sellerCountryOrArea, false);
      } else if (sellerStateCountryCode) {
        await getState(sellerStateCountryCode, false);
      }

      // Handle postcode / town / address disable states (disabled when pre-filled)
      setDisable((prev) => ({
        ...prev,
        buyerPostCode: !!data?.buyerPostcode,
        sellerPostCode: !!data?.sellerPostcode,
        sellerTown: normalizeTownFromLookup(data?.sellerTown).length > 0,
        buyerTown: !!data?.buyerTown,
        sellerAddress1: !!data?.sellerAddress1,
        buyerAddress1: !!data?.buyerAddress1,
        // Handle country and state disable states (only locked when present)
        ...(data?.buyerCountryOrArea ? { buyerCountry: true } : {}),
        ...(data?.buyerStateOrProvince ? { buyerState: true } : {}),
        ...(data?.sellerCountryOrArea ? { sellerCountry: true } : {}),
        ...(data?.sellerStateOrProvince ? { sellerState: true } : {}),
      }));

      setInitialValues(data);
      setZustandInitialState(data);
    };

    // Read the return flag AND the original (source) TC id off base details.
    const fetchReturnTcFlag = async (): Promise<{ isReturn: boolean; sourceTcId: string; sourceVersion?: string }> => {
      const transactionDetails = getTransactionDetailsFormValues() || {};
      const localIsReturn = isReturnValue(transactionDetails.tcIsReturn);
      const localSourceTcId = transactionDetails.returnTcId || "";
      const localSourceVersion = transactionDetails.returnTcSourceVersion || "";

      if (localIsReturn && localSourceTcId) {
        setIsReturnTc(localIsReturn);
        setTcStandards(
          Array.isArray(transactionDetails.tcStandard) ? transactionDetails.tcStandard : []
        );
        setTcIssueDate(transactionDetails.tcIssueDate || "");
        return { isReturn: localIsReturn, sourceTcId: localSourceTcId, sourceVersion: localSourceVersion };
      }

      if (!TE_ID) return { isReturn: false, sourceTcId: "", sourceVersion: "" };
      try {
        const response: any = await searchApi.executeGet(
          TCAppConfig.GET_TC_BASE_DETAILS_V4,
          { tcId: TE_ID }
        );
        const isReturn = isReturnValue(response?.data?.tcIsReturn);
        setIsReturnTc(isReturn);
        setTcStandards(
          Array.isArray(response?.data?.tcStandard) ? response.data.tcStandard : []
        );
        setTcIssueDate(response?.data?.tcIssueDate || "");
        return {
          isReturn,
          sourceTcId: response?.data?.returnTcId || "",
          sourceVersion: response?.data?.returnTcSourceVersion || "",
        };
      } catch (err) {
        console.error("Failed to fetch TC return flag:", err);
        return { isReturn: false, sourceTcId: "", sourceVersion: "" };
      }
    };

    // Load this TC's own saved buyer/seller. If none exists yet and this is a Return TC,
    // auto-fill (with roles swapped) from the original/source TC referenced on base details.
    const fetchTcBaseDetails = async (isReturn: boolean, sourceTcId: string, sourceVersion?: string) => {
      try {
        const response: any = await executeGet(
          TCAppConfig.GET_TC_BUYERSSELLERS_DETAILS_V4,
          { tcId: TE_ID }
        );
        const ownSeller = getTcSellerInformation(response?.data);
        const ownBuyer = getTcBuyerInformation(response?.data);
        const hasOwnData = !!(ownSeller?.sellerTeId || ownBuyer?.buyerTeId);

        if (response?.data && hasOwnData) {
          // Store seller SC standards separately (not displayed but needed for payload)
          if (ownSeller?.sellerScStandard) {
            setSellerScStandards(ownSeller.sellerScStandard);
          }
          const data: BuyerSellerDetails =
            mapBuyerSellerDetailsApiResponseToInitialValues(response.data);
          await applyBuyerSellerData(data);
        } else if (isReturn && sourceTcId) {
          // Return TC with no saved parties yet → auto-fill from the original TC.
          // Roles swap: return seller <- source buyer, return buyer <- source seller.
          const isV3 = sourceVersion === "V3";
          const sourceResponse: any = await executeGet(
            isV3 ? TCAppConfig.GET_TC_BUYERSSELLERS_DETAILS : TCAppConfig.GET_TC_BUYERSSELLERS_DETAILS_V4,
            { tcId: sourceTcId }
          );
          if (sourceResponse?.data) {
            let sourceBaseData: any = {};
            try {
              const sourceBaseResponse: any = await executeGet(
                isV3 ? TCAppConfig.GET_TC_BASE_DETAILS : TCAppConfig.GET_TC_BASE_DETAILS_V4,
                { tcId: sourceTcId }
              );
              sourceBaseData = sourceBaseResponse?.data || {};
            } catch (sourceBaseError) {
              console.error("Failed to fetch source TC CB Licensing Code:", sourceBaseError);
            }
            const data = mapReturnTcAutofillFromSource(
              { ...sourceResponse.data, tcCbLicensingCode: sourceBaseData.tcCbLicensingCode },
              TE_ID || ""
            );
            await applyBuyerSellerData(data);
            notify(
              "Buyer & Seller details auto-filled from the original TC (roles swapped). Please review and Save.",
              "info"
            );
          }
        }
        setIsDataInitialized(true);
      } catch (err) {
        console.error("Failed to fetch TC Base Details:", err);
        setIsDataInitialized(true);
      }
    };
    const getCountry = async () => {
      try {
        const result: any = await dtrackItService.getCountry();
        // Utills.cl(`getCountry result ${JSON.stringify(result)}`);
        const countries = result.data.map((t: any) => ({
          value: t.code_1,
          label: t.description_1 + " (" + t.code_1 + ")",
        }));
        // Utills.cl(`countries ${countries}`);
        setCountries(countries);
        setCountryCodes(countries);
        // Utills.cl(`getCountry ${countries}`)
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };
    const getBuyerCbLicensingCodes = async () => {
      try {
        const result: any = await dtrackItService.getCBLicensingCodes();
        const options = (Array.isArray(result?.data) ? result.data : []).map((item: any) => ({
          value: item.code_1,
          // 86ajjej2w: show the bare CB code (CB-XXX), matching the return-TC picker
          label: item.code_1,
        }));
        setBuyerScCbLicensingCodes(options);
      } catch (err) {
        console.error("Failed to fetch Buyer CB Licensing Codes:", err);
      }
    };
    const init = async () => {
      await Promise.all([getCountry(), getBuyerCbLicensingCodes()]);
      if (TE_ID) {
        // Resolve the return flag + source TC id first, then decide whether to
        // load saved parties or auto-fill them (swapped) from the original TC.
        const { isReturn, sourceTcId, sourceVersion } = await fetchReturnTcFlag();
        await fetchTcBaseDetails(isReturn, sourceTcId, sourceVersion);
      } else {
        setZustandInitialState();
        setIsDataInitialized(true);
      }
    };
    init();
    // //alert(typeof getTCStandard)
  }, []);

  const getState = async (buyersCountryOrArea: any, isBuyer: boolean) => {
    try {
      // alert(`buyersCountryOrArea ${buyersCountryOrArea}, isBuyer ${isBuyer}`)
      const result: any = await dtrackItService.getStateBasedonCountry(
        buyersCountryOrArea
      );
      const list = Array.isArray(result?.data) ? result.data : [];
      const states = list.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      if (isBuyer) {
        setBuyerStates(states);
      } else {
        setSellerStates(states);
      }
      // keep local and global state stores in sync
      setState(states);
      setStates(states);
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  // Simulate API call for fetching options
  const fetchTEDetallsFromAPI = async (
    value: string,
    offset: number,
    type: string,
    name?: string
  ): Promise<any[]> => {
    try {
      const queryParams: Record<string, any> = {
        query_param: type == "query" ? value : "",
        offset: offset,
        name: type == "name" ? value : "",
      };
      // Fetch TE Details using the getTEDetails function
      const response = await buyerSellerDetailsService.getTEDetails(
        queryParams
      );
      const data = response.data;
      Utills.cl(
        `fetchTEDetallsFromAPI details, query ${JSON.stringify(
          queryParams
        )} response data ${JSON.stringify(data)}`
      );

      return data;
    } catch (error) {
      console.error("Error fetching TE details:", error);
      throw error; // Re-throw error to handle it in the calling code
    }
  };

  // Fields that are cleared/re-derived when the party (TE-ID / name) selection
  // changes. Their previous touched flags would surface "required" errors the
  // moment the old values are cleared — before the new selection's data has
  // been populated — so the wrappers below reset them after the change handler
  // runs. Validation still fires on Save & Next / the next explicit edit.
  const SELLER_DEPENDENT_FIELDS = [
    "sellerName",
    "sellerTEId",
    "sellerAddress1",
    "sellerAddress2",
    "sellerAddress3",
    "sellerTown",
    "sellerPostcode",
    "sellerStateOrProvince",
    "sellerCountryOrArea",
    "sellerSCNumber",
    "sellerCertifiedOrganizationName",
    "sellerLicenseNumber",
    "sellerNonCertifiedTraderName",
  ];
  const BUYER_DEPENDENT_FIELDS = [
    "buyerName",
    "buyerTEId",
    "buyerAddress1",
    "buyerAddress2",
    "buyerAddress3",
    "buyerTown",
    "buyerPostcode",
    "buyerStateOrProvince",
    "buyerCountryOrArea",
    "buyerSCNumber",
    "buyerCertifiedOrganizationName",
  ];

  const clearDependentFieldTouches = (fieldNames: string[]) => {
    if (!formRef.current) return;
    const currentTouched: Record<string, any> = {
      ...(formRef.current.touched || {}),
    };
    fieldNames.forEach((fieldName) => {
      delete currentTouched[fieldName];
    });
    formRef.current.setTouched(currentTouched, false);
  };

  const withDependentTouchReset =
    (handler: (value: any) => any, dependentFields: string[]) =>
    async (value: any) => {
      await handler(value);
      clearDependentFieldTouches(dependentFields);
    };

  // Handle selection change from SearchInput
  const handleSellerTEIdValueChange = (value: any) => {
    // if (formRef.current.values.sellingOnBehalfOfFlag === "N") {
    //   formRef.current.setFieldValue(
    //     "sellerCertifiedOrganizationName",
    //     value == null ? "" : value.account_name
    //   );
    // }
    const fields = [
      "sellerAddress1",
      "sellerTown",
      "sellerPostcode",
      "sellerStateOrProvince",
      "sellerCountryOrArea",
      "sellerName",
      "sellerTEId",
      "sellerCertifiedOrganizationName",
      "sellerLicenseNumber"
    ];
    if (value == null) {
      setSellerCountryFilterCode("");
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setDisable((prev) => ({
        ...prev,
        sellerState: true,
        sellerCountry: true,
        sellerPostCode: true,
        sellerTown: true,
      }));
      setVisible((prev) => ({
        ...prev,
        sellerName: true,
        sellerTEIdLabel: true,
      }));
    } else {
      // If buyer TE ID is already present and equal to the selected seller TE ID
      const currentBuyerTEId = formRef.current?.values?.buyerTEId;
      const selectedSellerTEId = value?.TE_ID ?? value?.TEID ?? value?.TEId ?? null;
      if (currentBuyerTEId && selectedSellerTEId && currentBuyerTEId === selectedSellerTEId) {
        setSellerCountryFilterCode("");
        notify("Buyer TE ID must not be equal to Seller TE ID", "error");
        // reset only the second-selected field (seller TE ID in this handler)
        fields.forEach((field) => {
          formRef.current.setFieldValue(field, "");
        });
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
          sellerCountry: true,
          sellerPostCode: true,
          sellerTown: true,
        }));
        setVisible((prev) => ({
          ...prev,
          sellerName: true,
          sellerTEIdLabel: true,
        }));
        return;
      }
      formRef.current.setFieldValue("sellerName", value.account_name);
      formRef.current.setFieldValue("sellerTEId", value.TE_ID);
      // Reset SC Number and Certified Organization Name when TE ID changes
      formRef.current.setFieldValue("sellerSCNumber", "");
      formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
      formRef.current.setFieldValue("sellerLicenseNumber", "");
      setSellerScStandards([]);
      // formRef.current.setFieldValue("sellerAddress1", value.street);
      // formRef.current.setFieldValue("sellerTown", value.city);
      // formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      const sellerStateCountryCode = getCountryCodeFromState(value.state);
      setSellerCountryFilterCode(
        value.country ? "" : sellerStateCountryCode
      );
      if (value.country != null && value.country !== "") {
        // Pass plain country code to getState; the service will normalize formatting for the API
        getState(value.country, false);
      } else if (sellerStateCountryCode) {
        getState(sellerStateCountryCode, false);
      }

      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: false,
        }));
        formRef.current.setFieldValue("sellerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: true,
        }));
        formRef.current.setFieldValue("sellerAddress1", value.street);
      }

      applySellerTownFromLookup(value.city);

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: false,
        }));
        formRef.current.setFieldValue("sellerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: true,
        }));
        formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      }
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: true,
        }));
        formRef.current.setFieldValue("sellerCountryOrArea", value.country);
      }

      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          sellerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
        }));
        formRef.current.setFieldValue("sellerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        sellerName: false,
        sellerTEIdLabel: false,
      }));
    }
  };

  const handleSellerNamedValueChange = (value: any) => {
    // //alert(`form ${JSON.stringify(formRef.current.values)}`)
    // if (formRef.current.values.sellingOnBehalfOfFlag === "N") {
    //   formRef.current.setFieldValue(
    //     "sellerCertifiedOrganizationName",
    //     value == null ? "" : value.account_name
    //   );
    // }
    const fields = [
      "sellerAddress1",
      "sellerAddress2",
      "sellerAddress3",
      "sellerTown",
      "sellerPostcode",
      "sellerStateOrProvince",
      "sellerCountryOrArea",
      "sellerLicenseNumber",
      "sellerNonCertifiedTraderName",
      "sellerName",
      "sellerTEId",
      "sellerCertifiedOrganizationName"
    ];
    if (value == null) {
      setSellerCountryFilterCode("");
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setDisable((prev) => ({
        ...prev,
        sellerState: true,
        sellerCountry: true,
        sellerPostCode: true,
        sellerTown: true,
      }));
      setVisible((prev) => ({
        ...prev,
        sellerTEId: true,
      }));
    } else {
      // Prevent selecting the same name as the buyer
      const currentBuyerName = formRef.current?.values?.buyerName;
      const selectedSellerName = value?.account_name ?? null;
      if (currentBuyerName && selectedSellerName && currentBuyerName === selectedSellerName) {
        setSellerCountryFilterCode("");
        notify("Seller Name must not be equal to Buyer Name", "error");
        // clear only the seller fields so user can re-select
        try {
          formRef.current.setFieldValue("sellerName", "");
          formRef.current.setFieldValue("sellerTEId", "");
          formRef.current.setFieldValue("sellerAddress1", "");
          formRef.current.setFieldValue("sellerTown", "");
          formRef.current.setFieldValue("sellerPostcode", "");
          formRef.current.setFieldValue("sellerStateOrProvince", "");
          formRef.current.setFieldValue("sellerCountryOrArea", "");
          formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
          formRef.current.setFieldValue("sellerLicenseNumber", "");
          try { updateField("sellerName", ""); updateField("sellerTEId", ""); } catch (e) {}
        } catch (e) {
          fields.forEach((field) => { formRef.current?.setFieldValue(field, ""); });
        }
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
          sellerCountry: true,
          sellerPostCode: true,
          sellerTown: true,
        }));
        setVisible((prev) => ({
          ...prev,
          sellerTEId: true,
        }));
        return;
      }
      formRef.current.setFieldValue("sellerName", value.account_name);
      formRef.current.setFieldValue("sellerTEId", value.TE_ID);
      // Reset SC Number and Certified Organization Name when Seller Name changes
      formRef.current.setFieldValue("sellerSCNumber", "");
      formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
      formRef.current.setFieldValue("sellerLicenseNumber", "");
      setSellerScStandards([]);
      // formRef.current.setFieldValue("sellerAddress1", value.street);
      // formRef.current.setFieldValue("sellerTown", value.city);
      // formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      const sellerStateCountryCode = getCountryCodeFromState(value.state);
      setSellerCountryFilterCode(
        value.country ? "" : sellerStateCountryCode
      );
      if (value.country != null && value.country !== "") {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode, false);
      } else if (sellerStateCountryCode) {
        getState(sellerStateCountryCode, false);
      }

      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: false,
        }));
        formRef.current.setFieldValue("sellerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: true,
        }));
        formRef.current.setFieldValue("sellerAddress1", value.street);
      }

      applySellerTownFromLookup(value.city);

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: false,
        }));
        formRef.current.setFieldValue("sellerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: true,
        }));
        formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      }
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: true,
        }));
        formRef.current.setFieldValue("sellerCountryOrArea", value.country);
      }

      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          sellerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
        }));
        formRef.current.setFieldValue("sellerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        sellerTEId: false,
      }));
    }
  };

  const handleBuyerTEIdValueChange = async (value: any) => {
    const fields = [
      "buyerAddress1",
      "buyerTown",
      "buyerPostcode",
      "buyerStateOrProvince",
      "buyerCountryOrArea",
      "buyerName",
      "buyerTEId",
    ];
    if (value == null) {
      setBuyerCountryFilterCode("");
      setBuyerName("");
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setVisible((prev) => ({
        ...prev,
        buyerSearchName: true,
      }));
      setVisible((prev) => ({
        ...prev,
        disableBuyerTEName: false,
        buyerTEIdLabel: true,
      }));
      setDisable((prev) => ({
        ...prev,
        buyerCountry: true,
        buyerState: true,
        buyerPostCode: true,
        buyerTown: true,
      }));
    } else {
      // If seller TE ID is already present and equal to the selected buyer TE ID
      const currentSellerTEId = formRef.current?.values?.sellerTEId;
      const selectedBuyerTEId = value?.TE_ID ?? value?.TEID ?? value?.TEId ?? null;
      if (currentSellerTEId && selectedBuyerTEId && currentSellerTEId === selectedBuyerTEId) {
        setBuyerCountryFilterCode("");
        notify("Seller TE ID must not be equal to Buyer TE ID", "error");
        // reset only the second-selected field (buyer TE ID in this handler)
        fields.forEach((field) => {
          formRef.current.setFieldValue(field, "");
        });
        setVisible((prev) => ({
          ...prev,
          buyerSearchName: true,
        }));
        setVisible((prev) => ({
          ...prev,
          disableBuyerTEName: false,
          buyerTEIdLabel: true,
        }));
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
          buyerState: true,
          buyerPostCode: true,
          buyerTown: true,
        }));
        return;
      }
      formRef.current.setFieldValue("buyerName", value.account_name);
      formRef.current.setFieldValue("buyerTEId", value.TE_ID);
      // Reset SC Number and Certified Organization Name when Buyer TE ID changes.
      // For a non-certified buyer (isBuyerTeCertified === "No") keep them "na" (DAT-501:
      // Buyer SC No / Buyer Certified Organization Name autofill to "na" when not certified).
      {
        const naDefault = formRef.current.values?.isBuyerTeCertified === "No" ? "na" : "";
        formRef.current.setFieldValue("buyerSCNumber", naDefault);
        formRef.current.setFieldValue("buyerCertifiedOrganizationName", naDefault);
      }
      // formRef.current.setFieldValue("buyerAddress1", value.street);
      // formRef.current.setFieldValue("buyerPostcode", value.postal_code || "");
      setBuyerName(value.account_name);
      
      setVisible((prev) => ({
        ...prev,
        buyerSearchName: false,
        disableBuyerTEName: true,
        buyerTEIdLabel: false,
      }));
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          value.account_name
        );
      }
      const buyerStateCountryCode = getCountryCodeFromState(value.state);
      setBuyerCountryFilterCode(
        value.country ? "" : buyerStateCountryCode
      );
      if (value.country != null && value.country !== "") {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        await getState(countryCode, true);
      } else if (buyerStateCountryCode) {
        await getState(buyerStateCountryCode, true);
      }
      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          buyerAddress1: false,
        }));
        formRef.current.setFieldValue("buyerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerAddress1: true,
        }));
        formRef.current.setFieldValue("buyerAddress1", value.street || "");
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city || "");
      }
      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city);
      }

      if (value.postal_code == null) {
        // alert("buyer postal code null")
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: false,
        }));
        formRef.current.setFieldValue("buyerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: true,
        }));
        formRef.current.setFieldValue("buyerPostcode", value.postal_code);
      }

      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
        }));
        formRef.current.setFieldValue("buyerCountryOrArea", value.country);
      }
      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          buyerState: false,
        }));
        // //alert(disable.buyerState)
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerState: true,
        }));
        formRef.current.setFieldValue("buyerStateOrProvince", value.state);
      }
    }
  };

  const handleBuyerNameValueChange = (value: any) => {
    const fields = [
      "buyerAddress1",
      "buyerTown",
      "buyerPostcode",
      "buyerStateOrProvince",
      "buyerCountryOrArea",
      "buyerName",
      "buyerTEId",
    ];
    if (value == null) {
      setBuyerCountryFilterCode("");
      setBuyerName("");
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          ""
        );
      }
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setVisible((prev) => ({
        ...prev,
        buyerSeacrhTEId: true,
        disableBuyerTEId: false,
        buyerTEIdLabel:true
      }));
      setDisable((prev) => ({
        ...prev,
        buyerCountry: true,
        buyerState: true,
        buyerPostCode: true,
        buyerTown: true,
      }));
    } else {
      // Prevent selecting the same name as the seller
      const currentSellerName = formRef.current?.values?.sellerName;
      const selectedBuyerName = value?.account_name ?? null;
      if (currentSellerName && selectedBuyerName && currentSellerName === selectedBuyerName) {
        setBuyerCountryFilterCode("");
        notify("Buyer Name must not be equal to Seller Name", "error");
        // clear only buyer fields so user can re-select
        try {
          formRef.current.setFieldValue("buyerName", "");
          formRef.current.setFieldValue("buyerTEId", "");
          formRef.current.setFieldValue("buyerAddress1", "");
          formRef.current.setFieldValue("buyerTown", "");
          formRef.current.setFieldValue("buyerPostcode", "");
          formRef.current.setFieldValue("buyerStateOrProvince", "");
          formRef.current.setFieldValue("buyerCountryOrArea", "");
          formRef.current.setFieldValue("buyerSCNumber", "");
          formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
          try { updateField("buyerName", ""); updateField("buyerTEId", ""); } catch (e) {}
        } catch (e) {
          fields.forEach((field) => { formRef.current?.setFieldValue(field, ""); });
        }
        setVisible((prev) => ({
          ...prev,
          buyerSeacrhTEId: true,
          disableBuyerTEId: false,
          buyerTEIdLabel:true
        }));
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
          buyerState: true,
          buyerPostCode: true,
          buyerTown: true,
        }));
        setBuyerName("");
        return;
      }
      formRef.current.setFieldValue("buyerName", value.account_name);
      formRef.current.setFieldValue("buyerTEId", value.TE_ID);
      formRef.current.setFieldValue("buyerAddress1", value.street);
      // Reset SC Number and Certified Organization Name when Buyer Name changes.
      // Non-certified buyer keeps them "na" (DAT-501).
      {
        const naDefault = formRef.current.values?.isBuyerTeCertified === "No" ? "na" : "";
        formRef.current.setFieldValue("buyerSCNumber", naDefault);
        formRef.current.setFieldValue("buyerCertifiedOrganizationName", naDefault);
      }
      // formRef.current.setFieldValue("buyerTown", value.city || "");
      // formRef.current.setFieldValue("buyerPostcode", value.postal_code || "");
      setBuyerName(value?.account_name);
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          value.account_name
        );
      }
      const buyerStateCountryCode = getCountryCodeFromState(value.state);
      setBuyerCountryFilterCode(
        value.country ? "" : buyerStateCountryCode
      );
      if (value.country != null && value.country !== "") {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode, true);
      } else if (buyerStateCountryCode) {
        getState(buyerStateCountryCode, true);
      }
  
      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city);
      }
  
      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: false,
        }));
        formRef.current.setFieldValue("buyerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: true,
        }));
        formRef.current.setFieldValue("buyerPostcode", value.postal_code);
      }
  
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
        }));
        formRef.current.setFieldValue("buyerCountryOrArea", value.country);
      }
  
      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          buyerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerState: true,
        }));
        formRef.current.setFieldValue("buyerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        buyerSeacrhTEId: false,
      }));
      setVisible((prev) => ({
        ...prev,
        disableBuyerTEId: true,
        buyerTEIdLabel:false
      }));
    }
  };

  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  // const testFOrmCOnfig = {
  //   pageName: "buyer-seller-products",
  //   initialValues,
  //   validationSchema: buyerSellerDetailsValidationSchema,
  //   sections: [
  //     {
  //       title: "Seller Details",
  //       fields: [
  //         {
  //           label: "testlink",
  //           name: "sellerTEId",
  //           type: "toggle",
  //           gridSize: { xs: 12, md: 4 },
  //           required: true,
  //           props: {
  //            children: <NavLink to="/test">Test</NavLink>
  //           },
  //         }
  //       ]
  //     }
  //   ],
  //   handleSubmit: async (values: any) => {
  //     try {

  //     } catch (error) {
  //       setLoadingState(false)
  //       console.error("Error saving Buyer & Seller Details:", error);
  //     }
  //   },
  // }
  const handleDialogOpen = () => {
    setDialogOpen(true);
    const zustandData = getCurrentFormValues();
    const nonCertifiedTrader =
      zustandData?.nonCertifiedTrader?.length > 0
        ? zustandData?.nonCertifiedTrader
        : [];
    setStepData({ nonCertifiedTrader: nonCertifiedTrader });
  };
  const sellerCountryOptions = filterCountryOptionsByState(
    countries,
    sellerCountryFilterCode
  );
  const buyerCountryOptions = filterCountryOptionsByState(
    countries,
    buyerCountryFilterCode
  );
  const formConfig = {
    pageName: "buyer-seller-products",
    initialValues,
    readOnly: hasSubmitTc,
    validationSchema: buyerSellerDetailsValidationSchema,
    sections: [
      {
        title: "Seller Information",
        fields: [
          // Row 1: Column 1 - TE-ID, Column 2 - Name, Column 3 - Street Address
          {
            label: "Seller TE-ID",
            name: "sellerTEId",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerTEId,
            visible: (value: any) => visible.sellerTEId,
            props: {
              placeholder: "Search Seller TE-ID",
              variant: "outlined",
              restrictInputFormat: visible.sellerTEIdLabel,
              param: "SellerTEId",
              onChange: withDependentTouchReset(
                handleSellerTEIdValueChange,
                SELLER_DEPENDENT_FIELDS
              ),
              displayKey: "TE_ID",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Seller TE-ID",
            name: "sellerTEId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            disabled: true,
            visible: (value: any) => !visible.sellerTEId,
            props: {
              placeholder: "Enter Seller Name",
              fullWidth: true,
            },
          },
          {
            label: "Seller Name",
            name: "sellerName",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerName,
            visible: (value: any) => visible.sellerName,
            props: {
              placeholder: "Search Seller Name",
              variant: "outlined",
              onChange: withDependentTouchReset(
                handleSellerNamedValueChange,
                SELLER_DEPENDENT_FIELDS
              ),
              displayKey: "account_name",
              onSearch: (query: string, offset: number) => {
                Utills.cl(
                  `fetchTEDetallsFromAPI query ${query} offset ${offset}`
                );
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Seller Name",
            name: "sellerName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            disabled: true,
            visible: (value: any) => !visible.sellerName,
            props: {
              placeholder: "Enter Seller Name",
              fullWidth: true,
            },
          },
          {
            label: "Seller Street Address",
            name: "sellerAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            disabled: disable.sellerAddress1,
            props: {
              placeholder: "Enter Seller Address",
              fullWidth: true,
            },
          },
          // Row 2 (86ajey1be): Town | Postcode | Country/Area | State/Province on one line
          {
            label: "Seller Town",
            name: "sellerTown",
            type: "text",
            gridSize: { xs: 12, md: 3 },
            required: true,
            value: initialValues.sellerTown,
            disabled: disable.sellerTown,
            helperText: 'Please fill "na" if not available',
            props: {
              placeholder: "Enter town",
              fullWidth: true,
            },
          },
          {
            label: "Seller Postcode",
            name: "sellerPostcode",
            type: "text",
            gridSize: { xs: 12, md: 3 },
            required: true,
            value: initialValues.sellerPostcode,
            disabled: disable.sellerPostCode,
            helperText: 'Please fill "na" if not available',
            props: {
              placeholder: "Enter postcode",
              fullWidth: true,
            },
          },
          {
            label: "Seller Country/Area",
            name: "sellerCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 3 },
            required: true,
            value: initialValues.sellerCountryOrArea,
            disabled: disable.sellerCountry,
            events: {
              onChange: (newValue: any, updatedValues: any) => {
                const code = Array.isArray(newValue) ? newValue[0] : newValue;
                getState(code, false);
              },
            },
            props: {
              enableSearch: true,
              options: sellerCountryOptions,
              placeholder: "Seller Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Seller State/Province",
            name: "sellerStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 3 },
            required: true,
            value: initialValues.sellerStateOrProvince,
            disabled: disable.sellerState,
            props: {
              options: getSellerStates,
              enableSearch: true,
              placeholder: "Seller State/Province",
              fullWidth: true,
            },
          },
          // "TC Seller Product Declarations" is intentionally NOT rendered here:
          // the declaration text is captured on the Declarations tab (86ajcuj3g).
          // The value still round-trips through this tab's save payload from the
          // loaded form state so the stored declaration is never wiped.
          // Row 3 (86ajey1be): SC Number | CB Client Number | Certified Organization Name on one line
          {
            label: "Seller SC Number",
            name: "sellerSCNumber",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerSCNumber,
            visible: () => !isReturnTc,
            disabled: (values: any) => !values?.sellerTEId || values?.sellerTEId === "",
            props: {
              placeholder: "Search Seller SC Number",
              variant: "outlined",
              displayKey: "label",
              onChange: handleSellerSCValueChange,
              onSearch: (query: string) => {
                const sellerTEId = formRef.current?.values?.sellerTEId;
                if (!sellerTEId || sellerTEId === "") {
                  notify("Please select Seller TE ID first", "warning");
                  return Promise.resolve([]);
                }
                return fetchSCDetailsFromAPI(query, sellerTEId, 'Seller');
              },
              fullWidth: true,
            },
          },
          {
            label: "Seller SC Number",
            name: "sellerSCNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerSCNumber,
            visible: () => isReturnTc,
            disabled: false,
            helperText: 'Enter "na" if the seller is not certified',
            props: {
              placeholder: 'Enter Seller SC Number or "na"',
              fullWidth: true,
            },
          },
          {
            label: "Seller CB Client Number",
            name: "sellerLicenseNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            // Mandatory for normal TCs (auto-filled from the Seller SC). For a Return TC the
            // seller mirrors the original buyer and may be non-certified, so it is optional.
            required: true,
            value: initialValues.sellerLicenseNumber,
            // Read-only: autofilled from the selected Seller SC's certified org CB Client Number
            // (TC DAT-501 "seller CB client No" — user shall not fill). Editable only for Return TCs,
            // where the SC Number is typed manually and there is no dropdown to autofill from.
            disabled: !isReturnTc,
            helperText: isReturnTc ? 'Mandatory for Return TC — enter "na" if not applicable' : undefined,
            props: {
              placeholder: isReturnTc ? 'Enter Seller Client Number or "na"' : "Auto-filled from Seller SC",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "Seller Certified Organization Name",
            name: "sellerCertifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerCertifiedOrganizationName,
            // Normal TCs derive this value from the selected Seller SC. Return
            // TCs may use an open-text/"na" Seller SC and therefore remain editable.
            disabled: !isReturnTc,
            helperText: isReturnTc ? 'Enter "na" if the Seller SC Number is "na"' : undefined,
            props: {
              placeholder: isReturnTc
                ? "Enter Certified Organization Name"
                : "Auto-filled from Seller SC",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "",
            name: "nonCertifiedTrader",
            type: "component",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            children: (
              <>
                {" "}
                <CustomButton
                  sx={{
                    marginTop: "16px",
                    borderRadius: "30px",
                    padding: "10px 12px",
                    textTransform: "none",
                    backgroundColor: "#F0CD7F",
                    color: "#1C1C1C",
                    fontWeight: 400,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    "&:hover": {
                      backgroundColor: "#E0B86F",
                      color: "#000000",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                  onClick={handleDialogOpen}
                  variant="contained"
                  fullWidth
                  size="medium"
                  errorMessage=""
                  label={
                    stepData?.nonCertifiedTrader.length === 0 ? (
                      <>{hasSubmitTc ? "View" : "Add"} Non-Certified Trader Information</>
                    ) : (
                      <>{hasSubmitTc ? "View" : "Edit"} Non-Certified Trader Information</>
                    )
                  }
                />
                <span
                  style={{
                    fontSize: "0.8em",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {stepData?.nonCertifiedTrader.length} Records Added
                </span>
              </>
            ),
            props: {},
          },
        ],
      },
      {
        title: "Buyer Information",
        fields: [
          // {
          //   label: "Does the Buyer have a TE-ID?",
          //   name: "isBuyerTeCertified",
          //   type: "radio",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.isBuyerTeCertified,
          //   events: {
          //     onChange: (value: any) => {
          //       Utills.cl("buyer te certified", value);
          //       if (value === "Yes") {
          //         formRef.current.setFieldValue("buyerStateOrProvince", "");
          //         formRef.current.setFieldValue("buyerCountryOrArea", "");
          //         formRef.current.setFieldValue("buyerTEId", "");
          //         formRef.current.setFieldValue("buyerName", "");
          //         formRef.current.setFieldValue("buyerAddress1", "");
          //         formRef.current.setFieldValue("buyerAddress2", "");
          //         formRef.current.setFieldValue("buyerAddress3", "");
          //         formRef.current.setFieldValue("buyerTown", "");
          //         formRef.current.setFieldValue("buyerPostcode", "");
          //         formRef.current.setFieldValue("buyerLicenseNumber", "");

          //         setBuyerTeCertifiedVisbile(true);
          //         setVisible((prev) => ({
          //           ...prev,
          //           buyerSearchName: true,
          //           buyerSeacrhTEId: true,
          //           disableBuyerTEId: true,
          //           disableBuyerTEName: true,
          //         }));
          //         setDisable((prev) => ({
          //           ...prev,
          //           buyerCountry: true,
          //           buyerState: true,
          //           buyerPostCode: true,
          //         }));
          //       } else {
          //         formRef.current.setFieldValue("buyerStateOrProvince", "");
          //         formRef.current.setFieldValue("buyerCountryOrArea", "");
          //         formRef.current.setFieldValue("buyerTEId", "");
          //         formRef.current.setFieldValue("buyerName", "");
          //         formRef.current.setFieldValue("buyerAddress1", "");
          //         formRef.current.setFieldValue("buyerAddress2", "");
          //         formRef.current.setFieldValue("buyerAddress3", "");
          //         formRef.current.setFieldValue("buyerTown", "");
          //         formRef.current.setFieldValue("buyerPostcode", "");
          //         formRef.current.setFieldValue("buyerLicenseNumber", "");
          //         setBuyerTeCertifiedVisbile(false);
          //         setVisible((prev) => ({
          //           ...prev,
          //           buyerSeacrhTEId: false,
          //           buyerSearchName: true,
          //           disableBuyerTEId: false,
          //           disableBuyerTEName: true,
          //         }));
          //         setDisable((prev) => ({
          //           ...prev,
          //           buyerCountry: false,
          //           buyerState: false,
          //           buyerPostCode: false,
          //         }));
          //       }
          //     },
          //   },
          //   props: {
          //     options: [
          //       { value: "Yes", label: "Yes" },
          //       { value: "N", label: "No" },
          //     ],
          //   },
          // },
          {
            label: "Is the Buyer certified?",
            name: "isBuyerTeCertified",
            type: "radio",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.isBuyerTeCertified || "Yes",
            events: {
              onChange: (value: any, formValues: any, setFieldValue: any) => {
                if (value === "No") {
                  setFieldValue("buyerScCbLicensingCode", "");
                  setFieldValue("buyerSCNumber", "na");
                  setFieldValue("buyerCertifiedOrganizationName", "na");
                } else {
                  // Reset to default behavior for "Yes"
                  setFieldValue("buyerScCbLicensingCode", "");
                  setFieldValue("buyerSCNumber", "");
                  setFieldValue("buyerCertifiedOrganizationName", "");
                }
              },
            },
            props: {
              options: [
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" },
              ],
            },
          },
          {
            label: "Buyer TE-ID",
            name: "buyerTEId",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerTEId,
            visible: () => true,
            props: {
              placeholder: "Search Buyer TE-ID",
              variant: "outlined",
              displayKey: "TE_ID",
              restrictInputFormat: visible.buyerTEIdLabel,
              onChange: withDependentTouchReset(
                handleBuyerTEIdValueChange,
                BUYER_DEPENDENT_FIELDS
              ),
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Buyer TE-ID",
            name: "buyerTEId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            visible: () => false,
            props: {
              placeholder: "Enter Buyer TE-ID",
              fullWidth: true,
            },
          },
          // {
          //   label: "Buyer TE-ID",
          //   name: "buyerTEId",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   visible: (values: any) => true,
          //   disabled: visible.disableBuyerTEId,
          //   props: {
          //     placeholder: "Enter Buyer TE ID",
          //     fullWidth: true,
          //   },
          // },
          {
            label: "Buyer Name",
            name: "buyerName",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerName,
            visible: () => true,
            disabled: (values: any) =>
              !!(values?.buyerTEId && values?.sellerTEId && values?.buyerTEId === values?.sellerTEId),
            props: {
              placeholder: "Search Buyer Name",
              variant: "outlined",
              displayKey: "account_name",
              onChange: withDependentTouchReset(
                handleBuyerNameValueChange,
                BUYER_DEPENDENT_FIELDS
              ),
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          
          // ADD this new text field for Buyer Name when not certified:
          {
            label: "Buyer Name",
            name: "buyerName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            visible: () => false,
            disabled: (values: any) =>
              !!(values?.buyerTEId && values?.sellerTEId && values?.buyerTEId === values?.sellerTEId),
            props: {
              placeholder: "Enter Buyer Name",
              fullWidth: true,
            },
          },
          // {
          //   label: "Legal Name of Buyer",
          //   name: "buyerName",
          //   type: "search",
          //   gridSize: { xs: 12, md: 4 },
          //   required: getTCStandardGOTS ? false : true,
          //   value: initialValues.buyerName,
          //   visible: (values: any) => true,
          //   props: {
          //     placeholder: "Search Buyer Name",
          //     variant: "outlined",
          //     displayKey: "account_name",
          //     onChange: handleBuyerNameValueChange,
          //     onSearch: (query: string, offset: number) => {
          //       const response = fetchTEDetallsFromAPI(query, offset, "name");
          //       return response;
          //     },
          //     fullWidth: true,
          //   },
          // },
          {
            label: "Buyer Street Address",
            name: "buyerAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerAddress1,
            disabled: (values: any) => {
              if (!disable.buyerAddress1) return false;
              return true;
            },
            props: {
              placeholder: "Enter Buyer Address",
              fullWidth: true,
            },
          },
          // {
          //   label: "Buyer Address 2",
          //   name: "buyerAddress2",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.buyerAddress2,
          //   disabled: (values: any) => values?.isBuyerTeCertified !== "N",
          //   props: {
          //     placeholder: "Enter Buyer Address 2",
          //     fullWidth: true,
          //   },
          // },
          // {
          //   label: "Buyer Address 3",
          //   name: "buyerAddress3",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.buyerAddress3,
          //   disabled: (values: any) => values?.isBuyerTeCertified !== "N",
          //   props: {
          //     placeholder: "Enter Buyer Address 3",
          //     fullWidth: true,
          //   },
          // },
          // Row 2: Column 1 - Town, Column 2 - Postcode, Column 3 - CB Client Number
          {
            label: "Buyer Town",
            name: "buyerTown",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerTown,
            disabled: (values: any) => {
              if (!disable.buyerTown) return false;
              return true;
            },
            props: {
              placeholder: "Enter town",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Postcode",
            name: "buyerPostcode",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerPostcode,
            disabled: (values: any) => {
              if (!disable.buyerPostCode) return false;
              return true;
            },
            helperText: 'Please fill "na" if not available',
            props: {
              placeholder: "Enter postcode",
              fullWidth: true,
            },
          },
          {
            label: "Buyer CB Client Number",
            name: "buyerLicenseNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.buyerLicenseNumber,
            props: {
              placeholder: "Enter Buyer Client Number",
              variant: "outlined",
              fullWidth: true,
            },
          },
          // Row 3: Column 1 - Country/Area, Column 2 - State/Province, Column 3 - (empty)
          {
            label: "Buyer Country/Area",
            name: "buyerCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerCountryOrArea,
            disabled: (values: any) => {
              return disable.buyerCountry;
            },
            events: {
              onChange: (newValue: any, updatedValues: any) => {
                let countryCode = JSON.stringify(
                  `[${[newValue].map((item) => `'${item}'`)}]`
                ).replace(/^"|"$/g, "");
                getState(countryCode, true);
              },
            },
            props: {
              enableSearch: true,
              options: buyerCountryOptions,
              placeholder: "Select Buyer Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Buyer State/Province",
            name: "buyerStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerStateOrProvince,
            disabled: (values: any) => disable.buyerState,
            props: {
              options: getBuyerStates,
              enableSearch: true,
              placeholder: "Select Buyer State/Province",
              fullWidth: true,
            },
          },
          {
            label: "Buyer CB Licensing Code",
            name: "buyerScCbLicensingCode",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerScCbLicensingCode,
            visible: (values: any) => values?.isBuyerTeCertified !== "No",
            events: {
              onChange: (_newValue: any, _updatedValues: any, setFieldValue: any) => {
                setFieldValue("buyerSCNumber", "");
                setFieldValue("buyerCertifiedOrganizationName", "");
                setFieldValue("buyerLicenseNumber", "");
              },
            },
            props: {
              enableSearch: true,
              options: buyerScCbLicensingCodes,
              placeholder: "Select Buyer CB Licensing Code",
              fullWidth: true,
            },
          },
          // Buyer SC search is scoped by both Buyer TE-ID and the selected CB.
          {
            label: "Buyer SC Number",
            name: "buyerSCNumber",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerSCNumber,
            visible: (values: any) =>
              !isReturnTc && values?.isBuyerTeCertified !== "No",
            disabled: (values: any) =>
              !values?.buyerTEId ||
              values?.buyerTEId === "" ||
              !values?.buyerScCbLicensingCode,
            props: {
              placeholder: "Search Buyer SC Number",
              variant: "outlined",
              displayKey: "label",
              onChange: (selected: any) => {
                if (selected) {
                  const sellerSCNumber = formRef.current.values.sellerSCNumber;
                  if (sellerSCNumber && (selected.value === sellerSCNumber || selected.scNo === sellerSCNumber)) {
                    notify("Buyer SC Number must be different from Seller SC Number", "error");
                    formRef.current.setFieldValue("buyerSCNumber", "");
                    formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
                    return;
                  }
                  formRef.current.setFieldValue("buyerSCNumber", selected.value || selected.scNo);
                  formRef.current.setFieldValue("buyerCertifiedOrganizationName", selected.certifiedOrganizationName || "");
                } else {
                  formRef.current.setFieldValue("buyerSCNumber", "");
                  formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
                }
              },
              onSearch: (query: string) => {
                const buyerTEId = formRef.current?.values?.buyerTEId;
                const buyerCbCode = formRef.current?.values?.buyerScCbLicensingCode;
                if (!buyerTEId || buyerTEId === "") {
                  notify("Please select Buyer TE ID first", "warning");
                  return Promise.resolve([]);
                }
                if (!buyerCbCode) {
                  notify("Please select Buyer CB Licensing Code first", "warning");
                  return Promise.resolve([]);
                }
                return fetchSCDetailsFromAPI(query, buyerTEId, 'Buyer');
              },
              fullWidth: true
            }
          },
          {
            label: "Buyer SC Number",
            name: "buyerSCNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerSCNumber,
            visible: (values: any) =>
              isReturnTc || values?.isBuyerTeCertified === "No",
            disabled: (values: any) =>
              !isReturnTc && values?.isBuyerTeCertified === "No",
            props: {
              placeholder: isReturnTc ? "Enter Buyer SC Number" : "na",
              fullWidth: true
            }
          },
          // {
          //   label: "Buying On Behalf Of Flag",
          //   name: "buyingOnBehalfOfFlag",
          //   type: "radio",
          //   gridSize: { xs: 12, md: 4 },
          //   required: (value: any) => {
          //     if (getTCStandardGOTS) {
          //       return false;
          //     }
          //     return value?.buyingOnBehalfOfFlag == "Yes";
          //   },
          //   value: initialValues.buyingOnBehalfOfFlag,
          //   events: {
          //     onChange: (value: any) => {
          //       setBuyingOnBehalfOfFlag(value);
          //       if (value === "Yes") {
          //         formRef.current.setFieldValue(
          //           "buyerCertifiedOrganizationName",
          //           ""
          //         );
          //       } else {
          //         formRef.current.setFieldValue(
          //           "buyerCertifiedOrganizationName",
          //           getBuyerName
          //         );
          //       }
          //     },
          //   },
          //   props: {
          //     options: [
          //       { value: "Yes", label: "Yes" },
          //       { value: "N", label: "No" },
          //     ],
          //   },
          // },
          {
            label: "Buyer Certified Organization Name",
            name: "buyerCertifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            // readOnly: true,
            value: initialValues.buyerCertifiedOrganizationName,
            disabled: (values: any) =>
              !isReturnTc && values?.isBuyerTeCertified === "No",
            props: {
              placeholder: "Enter Certified Organization Name",
              variant: "outlined",
              fullWidth: true
            },
          },
        ],
      },
    ],
    handleSubmit: async (values: any) => {
      // The save POST runs on its own useApi instance, so the form stays
      // mounted (and every entered value stays put) whether or not it succeeds.

      // DAT-501 seller-SC rule 3 (86ajey1h1): block Save & Next when the attached
      // Seller SC does not carry every TC standard (covers SCs selected before a
      // later standard change on the Transaction Information tab).
      if (!isReturnTc) {
        const missingStandards = missingSellerScStandards(
          tcStandards,
          sellerScStandards
        );
        if (missingStandards.length > 0) {
          notify(
            `The Seller SC does not include the TC standard(s): ${missingStandards.join(
              ", "
            )}. Select a different Seller SC or change the TC standard.`,
            "error"
          );
          return;
        }
      }

      try {
        const buyerSellerDatas = getCurrentFormValues();
        const payload = mapPayload(
          buyerSellerDatas,
          TE_ID,
          getBuyerStates,
          getSellerStates,
          sellerScStandards,
          isReturnTc
        );

        Utills.cl("Buyer Seller Form Submitted:", JSON.stringify(payload), 2);

        const result: any = await saveApi.executePost(
          TCAppConfig.POST_BUYER_SELLER_DETAILS_V4,
          payload
        );

        if (result?.status === 200) {
          notify("Saved Successfully", "success");

          // Use the tcId returned from API if available, otherwise fall back to route param
          const tcId = result.data?.tcId || TE_ID;

          // Let parent refresh completion map
          await onNextTab();

          // Navigate to next tab (Shipments) for create/edit flow
          if (!hasSubmitTc && tcId) {
            navigate(`/v4/tc/${formtype || "create-tc"}/shipment-details/${tcId}`);
          }
        } else {
          // Highlight the exact fields the backend rejected (it replies with a
          // [{field, message}] list) and keep the user on this tab.
          const fieldErrors = extractApiFieldErrors(result?.data);
          if (fieldErrors.length > 0 && formRef.current) {
            const unmapped = applyApiFieldErrorsToFormik(
              fieldErrors,
              formRef.current,
              BUYER_SELLER_API_FIELD_TO_FORM_FIELD
            );
            // Translate internal backend field paths to UI labels before
            // toasting (raw property names must never reach users - 86ajcn0z8).
            unmapped.forEach((fieldError) =>
              notify(
                fieldError.field
                  ? translateTcV4ValidationDetail({
                      field: fieldError.field,
                      message: fieldError.message,
                    })
                  : fieldError.message,
                "error"
              )
            );
            if (unmapped.length < fieldErrors.length) {
              notify(
                "Unable to save — please fix the highlighted fields",
                "error"
              );
              scrollToFirstFormError();
            }
          }
          // Otherwise useApi already toasted the specific backend error.
          return;
        }
      } catch (error) {
        console.error("Error saving Buyer & Seller Details:", error);
        notify("An error occurred while saving. Please try again.", "error");
        return;
      }
    },
  };

  // Ref to access the Formik instance in FormBuilder
  const formRef = useRef<any>(null);

  const handleSaveNonCertsTrader = async () => {
    if (stepData.nonCertifiedTrader.length === 0) {
      notify("Please add Non-Certified Trader Info", "error");
      return;
    }
    formRef.current.setFieldValue(
      "nonCertifiedTrader",
      stepData.nonCertifiedTrader
    );
    setDialogOpen(false);
    updateField("nonCertifiedTrader", stepData.nonCertifiedTrader);
    // setStepData({
    //   nonCertifiedTrader: nonCertifiedTraderDatas
    // })
  };

  const handleSubmit = async () => {
    try {
     if (hasSubmitTc) {
      navigate(`/v4/tc/${formtype}/shipment-details/${TE_ID}`);
    } else if (formRef.current) {
      // Validate up-front so an invalid form reports WHY instead of silently doing
      // nothing on "Save & Next" (the original Return-TC bug).
      const errors = await formRef.current.validateForm();
      const errorKeys = errors ? Object.keys(errors) : [];
      if (errorKeys.length > 0) {
        // Mark invalid fields touched so their inline errors render.
        formRef.current.setTouched(
          errorKeys.reduce((acc: any, key: string) => ({ ...acc, [key]: true }), {}),
          false
        );
        const firstError: any = errors[errorKeys[0]];
        const message =
          typeof firstError === "string"
            ? firstError
            : Array.isArray(firstError)
            ? "Please complete the Non-Certified Trader details"
            : "Please complete the highlighted required fields";
        notify(message, "error");
        scrollToFirstFormError();
        return;
      }
      formRef.current.submitForm(); // Programmatically submit the form
    }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      notify("Failed to save and navigate to next tab", "error");
    }
  }

  // const handleBack = () => {
  //     if (hasSubmitTc || hasRejectedTc) {
  //     // Navigate to previous tab in review mode
  //     navigate(`/v4/tc/${formtype}/base-details/${TE_ID}`);
  //   }
  // };

  return (
    <Box>
      {/* Render the FormBuilder component and pass formRef and onSubmit handler */}
      {loading || !isDataInitialized ? (
        <LoaderComponent />
      ) : (
        <>
          <FormBuilderV4
            formConfig={formConfig}
            onSubmit={formConfig.handleSubmit}
            formRef={formRef}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              gap: "0.5rem"
            }}
          >
             <NavLink
              to={`/v4/tc-dashboard`}
            >
              <StyledButton variant="contained"   sx={{ boxShadow:"none" }}>
                 Home
              </StyledButton>
            </NavLink>
             <NavLink
              to={`/v4/tc/${formtype}/base-details/${TE_ID}`}
            >
              <StyledButton variant="contained"   sx={{ boxShadow:"none" }}>
                 Back
              </StyledButton>
            </NavLink>
            <StyledButton
              variant="contained"
              sx={{ boxShadow: "none" }}
              onClick={handleSubmit}
              disabled={saveApi.loading}
            >
              {saveApi.loading ? "Saving..." : hasSubmitTc ? "Next" : "Save & Next"}
            </StyledButton>
          </Box>
        </>
      )}
      <ModalPopup
        open={dialogOpen}
        onSave={handleSaveNonCertsTrader}
        onClose={() => {
          setDialogOpen(false);
        }}
        disableSave = {isRestrictPopUpSave}
      >
        <NonCertifiedTraderInfo
          nonCertifiedInfoData={stepData.nonCertifiedTrader}
          setNonCertifiedInfoData={(data) =>
            handleDataUpdate("nonCertifiedTrader", data)
          }
        />
      </ModalPopup>
    </Box>
  );
};

export default SellerCertifiedProducts;
